module.exports = __webpack_public_path__ + "video-unmute.svg?952e3b6ad14e48f26383f3617650439a";